import { Controller } from '@hotwired/stimulus';

/**
 * Generic value-driven enable/disable controller.
 *
 * Wires a group of "trigger" inputs (typically radios) to "targetGroup" containers.
 * When a trigger is checked, the target group whose `data-value` matches the trigger
 * value is enabled and others are disabled. Disabled groups also receive `text-muted`.
 *
 * Usage:
 *   div data-controller="value-toggle"
 *     input type="radio" value="a" data-value-toggle-target="trigger" data-action="change->value-toggle#refresh"
 *     input type="radio" value="b" data-value-toggle-target="trigger" data-action="change->value-toggle#refresh"
 *     div data-value-toggle-target="targetGroup" data-value="a"
 *       input type="text"
 *     div data-value-toggle-target="targetGroup" data-value="b"
 *       input type="text"
 */
export default class extends Controller {
  static targets = ['trigger', 'targetGroup']

  connect() {
    this.refresh();
  }

  refresh() {
    const checked = this.triggerTargets.find((input) => input.checked);
    const value = checked?.value;

    this.targetGroupTargets.forEach((group) => {
      const enabled = group.dataset.value === value;
      group.classList.toggle('text-muted', !enabled);
      group.querySelectorAll('input, select, textarea').forEach((field) => {
        field.disabled = !enabled;
      });
    });
  }
}
